import Immutable from "seamless-immutable";
import {
  GET_TWILIO_GET_FILE_STATUS,
  GET_TWILIO_GET_FILE_STATUS_SUCCESS,
  GET_TWILIO_GET_FILE_STATUS_FAILURE,
  GET_TWILIO_REQUEST_OTP,
  GET_TWILIO_REQUEST_OTP_SUCCESS,
  GET_TWILIO_REQUEST_OTP_FAILURE,
  GET_TWILIO_GET_FILE,
  GET_TWILIO_GET_FILE_SUCCESS,
  GET_TWILIO_GET_FILE_FAILURE,
} from "../actions/twilio";

const INITIAL_STATE = Immutable({
  getTwilioGetFileStatus: null,
  getTwilioRequestOtp: null,
  getTwilioGetFile: null,
});

function policy(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_TWILIO_GET_FILE_STATUS:
      return state
        .setIn(["getTwilioGetFileStatus", "loading"], true)
        .setIn(["getTwilioGetFileStatus", "status"], false);
    case GET_TWILIO_GET_FILE_STATUS_SUCCESS:
      return state
        .setIn(["getTwilioGetFileStatus", "loading"], false)
        .setIn(["getTwilioGetFileStatus", "items"], action.data)
        .setIn(["getTwilioGetFileStatus", "status"], true);
    case GET_TWILIO_GET_FILE_STATUS_FAILURE:
      return state
        .setIn(["getTwilioGetFileStatus", "loading"], false)
        .setIn(["getTwilioGetFileStatus", "status"], false);
    case GET_TWILIO_REQUEST_OTP:
      return state
        .setIn(["getTwilioRequestOtp", "loading"], true)
        .setIn(["getTwilioRequestOtp", "status"], false);
    case GET_TWILIO_REQUEST_OTP_SUCCESS:
      return state
        .setIn(["getTwilioRequestOtp", "loading"], false)
        .setIn(["getTwilioRequestOtp", "items"], action.data)
        .setIn(["getTwilioRequestOtp", "status"], true);
    case GET_TWILIO_REQUEST_OTP_FAILURE:
      return state
        .setIn(["getTwilioRequestOtp", "loading"], false)
        .setIn(["getTwilioRequestOtp", "status"], false);
    case GET_TWILIO_GET_FILE:
      return state
        .setIn(["getTwilioGetFile", "loading"], true)
        .setIn(["getTwilioGetFile", "status"], false);
    case GET_TWILIO_GET_FILE_SUCCESS:
      return state
        .setIn(["getTwilioGetFile", "loading"], false)
        .setIn(["getTwilioGetFile", "items"], action.data)
        .setIn(["getTwilioGetFile", "status"], true);
    case GET_TWILIO_GET_FILE_FAILURE:
      return state
        .setIn(["getTwilioGetFile", "loading"], false)
        .setIn(["getTwilioGetFile", "status"], false);
    default:
      return state;
  }
}

export default policy;
